document.addEventListener('DOMContentLoaded', function () {

    var items = document.querySelectorAll('section.carousell-insta .piki-carousel--item')

    items.forEach(function (item) {

        var iframe = item.querySelector('iframe')
        if (!iframe) {
            return
        }

        item.classList.add('is-loading')

        var reveal = function () {
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
            item.classList.remove('is-loading')
            item.classList.add('is-loaded')
        }

        // O Complianz pode adiar o carregamento real (src fica em
        // "about:blank" até o consentimento de cookies de marketing) —
        // ignora esse load inicial e só tira o skeleton quando o iframe
        // navega de fato pra uma URL real do Instagram.
        iframe.addEventListener('load', function () {

            var src = iframe.getAttribute('src') || ''
            if (src === '' || src === 'about:blank') {
                return
            }

            reveal()

        })

        // Rede de segurança: se por algum motivo o load nunca disparar
        // (embed lento, bloqueado, etc.), libera o skeleton mesmo assim
        // depois de um tempo, em vez de ficar recolhido pra sempre.
        var timeoutId = setTimeout(reveal, 15000)

    })

})
